import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { TimeTable } from '../types/hospital.type'

import Text from '@/components/atomic/atoms/Text'
import COLOR from '@/components/cell/designTokens/color'
import Section from '@/components/atomic/molecules/Section'

interface Props {
  officeHours: TimeTable
  comment: string
}

export const HospitalOfficeHours: FC<Props> = ({ officeHours, comment }) => {
  const { t } = useTranslation()

  const days = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'] as (keyof TimeTable)[]
  const daysText: Record<keyof TimeTable, string> = {
    MON: t('templates.hospitalDetail.timeTable.days.MON'),
    TUE: t('templates.hospitalDetail.timeTable.days.TUE'),
    WED: t('templates.hospitalDetail.timeTable.days.WED'),
    THU: t('templates.hospitalDetail.timeTable.days.THU'),
    FRI: t('templates.hospitalDetail.timeTable.days.FRI'),
    SAT: t('templates.hospitalDetail.timeTable.days.SAT'),
    SUN: t('templates.hospitalDetail.timeTable.days.SUN'),
  }
  const holidayText = t('templates.hospitalDetail.timeTable.holiday') ?? '-'

  return (
    <Section title={t('templates.hospitalDetail.officeHoursTitle')}>
      <div>
        <table
          style={{
            width: '100%',
            border: '1px solid #d6d6d6',
            borderWidth: '1px 0',
            borderCollapse: 'collapse',
          }}
        >
          <thead>
            <tr>
              {days.map((day, index) => (
                <th
                  key={index}
                  style={{
                    padding: '6px',
                    width: '14.28%',
                    backgroundColor: COLOR.lightYellow,
                    borderRight: '1px solid #d6d6d6',
                    color: day === 'SAT' ? '#114cf5' : day === 'SUN' ? COLOR.ban : 'inherit',
                  }}
                >
                  <Text type="caption2">{daysText[day]}</Text>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {days.map((day, index) => (
                <td
                  key={index}
                  style={{
                    padding: '6px',
                    textAlign: 'center',
                    whiteSpace: 'pre-wrap',
                    borderRight: '1px solid #d6d6d6',
                    backgroundColor: officeHours[day] ? 'transparent' : COLOR.gray200,
                  }}
                >
                  {!!officeHours[day] && (
                    <Text element="p" type="caption2">
                      {`${officeHours[day]?.split('-')[0]}\n~\n${officeHours[day]?.split('-')[1]}`}
                    </Text>
                  )}
                  {!officeHours[day] && (
                    <Text type="caption2" color={'#4C4C4C'}>
                      {holidayText}
                    </Text>
                  )}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
        {comment && (
          <Text element="p" type="caption2" style={{ marginTop: '16px' }}>
            {comment}
          </Text>
        )}
      </div>
    </Section>
  )
}
